import Vue from "vue";
import {reactive, toRefs, computed, provide, inject, isRef} from "@vue/composition-api";
import axios from "axios";
import ApiProfile from '@/api/profile/profile'
import ApiHashLogin from '@/api/user/hashLogin'
import {updateListState} from "../store_helpers";
import router from "../../router";
import {actions as appActions} from "../modules/app";
import errorDialog from "@/views/ErrorDialog/errorDialog"
import {getCookie} from "@/helpers/helpers";
import * as IntercomModule from "../../modules/intercom/intercom";
import {APP_STORE_APP_TYPES} from '../../helpers/constants'

export const state = reactive({
    current_account: {id: 0},
    loading: true,
    accounts_info: [],
    //map: new Map(),
    list: [],
    all_accounts: [],
});

export const actions = {
    fetchAdminData(type, params) {
        let url = null
        if (type === 'lead') url = Vue.config.url_prefix + "/api/admin/contact"
        if (type === 'person') url = Vue.config.url_prefix + "/api/admin/contact"
        if (type === 'company') url = Vue.config.url_prefix + "/api/admin/company"
        if (type === 'demo') url = Vue.config.url_prefix + "/api/admin/demo"
        if (type === 'kpi') url = Vue.config.url_prefix + "/api/admin/kpi"
        if (!url) return

        params['contact_type'] = type
        return new Promise(function (resolve, reject) {
            axios
                .get(url, {params: params})
                .then(function (response) {
                    resolve(response.data);
                })
                .catch(function (ex) {
                    reject(ex);
                });
        });
    },
    saveAdminData(type, data) {
        let url = null
        if (type === 'lead') url = Vue.config.url_prefix + "/api/admin/contact/{0}?contact_type={1}".format(data.row_id, type)
        if (type === 'person') url = Vue.config.url_prefix + "/api/admin/contact/{0}?contact_type={1}".format(data.row_id, type)

        if (type === 'company') url = Vue.config.url_prefix + "/api/admin/company/{0}".format(data.row_id)
        if (type === 'demo') url = Vue.config.url_prefix + "/api/admin/demo/{0}".format(data.row_id)
        if (!url) return

        return new Promise(function (resolve, reject) {
            axios
                .post(url, data)
                .then(function (resp) {
                    resolve(resp.data);
                })
                .catch(function (ex) {
                    reject(ex);
                });
        });
    },
    registerAdminData(company_id, data) {
        let url = Vue.config.url_prefix + "/api/admin/register/{0}".format(company_id)
        return new Promise(function (resolve, reject) {
            axios
                .post(url, data)
                .then(function (resp) {
                    resolve(resp.data);
                })
                .catch(function (ex) {
                    reject(ex);
                });
        });
    },

    fetchSettingsState() {
        // TODO: catch
        ApiProfile.getProfileOld(state.current_account.id).then(function (response) {
            /*response.my_accounts.forEach(my_acc => {
                delete my_acc.name;
                updateListState(my_acc.id, my_acc, state.list);
            });
            delete response.my_accounts;
            delete response.name;*/
            state.current_account = Object.assign({}, state.current_account, response);
            state.loading = false;
        });
    },
    fetchAccount(account_id, params = null) {
        // Fetch active and inactive accounts
        return new Promise(function (resolve, reject) {
            params.account_id = account_id;
            axios
                .get(Vue.config.url_prefix + "/api/accounts", {params: params})
                .then(function (resp) {
                    resolve(resp.data);
                })
                .catch(function (ex) {
                    reject(ex);
                });
        });
    },
    putAccount(data) {
        return new Promise(function (resolve, reject) {
            let account_id = data.id ? data.id : "";
            axios
                .put(Vue.config.url_prefix + "/api/profile/{0}".format(account_id), data)
                .then(function (resp) {
                    if (resp.data.id === state.current_account.id) {
                        state.current_account = Object.assign({}, state.current_account, resp.data);
                    }
                    updateListState(resp.data.id, resp.data, state.list);
                    resolve(resp.data);
                })
                .catch(function (ex) {
                    reject(ex);
                });
        });
    },
    updateAccountSettings(data) {
        if (data.id === state.current_account.id) {
            state.current_account = Object.assign({}, state.current_account, data);
        } else {
            for (let i = 0; i < state.all_accounts.length; i++) {
                let acc = state.all_accounts[i];
                if (data.id === acc.id) {
                    Vue.set(state.all_accounts, i, Object.assign({}, acc, data));
                    break;
                }
            }

            for (let i = 0; i < state.list.length; i++) {
                let acc = state.list[i];
                if (data.id === acc.id) {
                    Vue.set(state.list, i, Object.assign({}, acc, data));
                    break;
                }
            }
        }
    },
    putAccountSetup(data) {
        return new Promise(function (resolve, reject) {
            let account_id = data.id ? data.id : "";
            axios
                .put(Vue.config.url_prefix + "/api/profile/{0}".format(account_id), data)
                .then(function (resp) {
                    if (resp.data.id === state.current_account.id) {
                        state.current_account = Object.assign({}, state.current_account, resp.data);
                    }

                    for (let i = 0; i < state.all_accounts.length; i++) {
                        let acc = state.all_accounts[i];
                        if (resp.data.id === acc.id) {
                            Vue.set(state.all_accounts, i, Object.assign({}, acc, resp.data));
                            break;
                        }
                    }

                    for (let i = 0; i < state.list.length; i++) {
                        let acc = state.list[i];
                        if (resp.data.id === acc.id) {
                            Vue.set(state.list, i, Object.assign({}, acc, resp.data));
                            break;
                        }
                    }
                    resolve();
                })
                .catch(function (ex) {
                    reject(ex);
                });
        });
    },
    deleteAccount(account_id) {
        return new Promise(function (resolve, reject) {
            axios
                .delete(Vue.config.url_prefix + "/api/profile/{0}".format(account_id))
                .then(resp => {
                    if (resp.data.success) {
                        updateListState(account_id, null, state.list);
                    }
                    resolve();
                })
                .catch(ex => reject(ex));
        });
    },
    postProfile(data) {
        return new Promise(function (resolve, reject) {
            axios
                .post(Vue.config.url_prefix + "/api/profile/", data)
                .then(resp => {
                    updateListState(resp.data.id, resp.data, state.list);
                    resolve(resp.data);
                })
                .catch(ex => reject(ex));
        });
    },
    setSettings(account_id, data) {
        return new Promise((resolve, reject) => {
            axios
                .post(Vue.config.url_prefix + "/api/account_setting/{0}".format(account_id), data)
                .then(resp => {
                    let account = state.accounts_info.find(x => x.id === account_id);
                    if (account != null) {
                        // console.log(account.data);
                        for (let prop in data) {
                            if (Object.prototype.hasOwnProperty.call(data, prop)) {
                                Vue.set(account.data, prop, data[prop]);
                            }
                        }
                        // console.log(account.data);
                    }
                    resolve(resp);
                })
                .catch(ex => reject(ex));
        });
    },
    getSettings(account_id, name) {
        let account = state.accounts_info.find(x => x.id === account_id);
        if (account != null) {
            return account.data[name];
        }
        return null;
    },
    isFeatureEnabled(account_id, name, alert = true) {
        let account = state.accounts_info.find(x => x.id === account_id);
        let enabled = account != null && account.features != null && account.features.indexOf(name) >= 0;
        if (!enabled && alert) appActions.showFeatureNotEnabled(account);
        return enabled;
    },
    isAnyIntegrationEnabled(account_id) {
        let account = state.accounts_info.find(x => x.id === account_id);
        const integrations = [
            APP_STORE_APP_TYPES.MERIT_AKTIVA,
            APP_STORE_APP_TYPES.SMART_ACCOUNTS,
            APP_STORE_APP_TYPES.ECONOMIC,
            APP_STORE_APP_TYPES.XERO,
            APP_STORE_APP_TYPES.QUICKBOOKS,
            APP_STORE_APP_TYPES.TRIPLETEX,
            APP_STORE_APP_TYPES.FORTNOX,
            APP_STORE_APP_TYPES.FREEAGENT
        ]
        const enabled = account != null && account.features != null && account.features && account.features.some((feature) => integrations.includes(feature))
        return !!enabled
    },
    isFeatureEnabledAnywhere(name, alert = true) {
        for (let account of state.accounts_info) {
            let enabled = account != null && account.features != null && account.features.indexOf(name) >= 0;
            if (enabled) return true;
        }
        return false;
    },
    isBundle(account_id, alert = true) {
        let account = state.accounts_info.find(x => x.id === account_id);
        let enabled = account != null && account.bundles.length > 0;
        if (!enabled && alert) appActions.showFeatureNotEnabled(account);
        return enabled;
    },
    async hashLoginForJoin(name, email, invitationHash) {
        let response;
        try {
            response = await ApiHashLogin.joinPendingLogin(name, email, invitationHash);
        } catch (error) {
            //pass
        }
        return response;
    },
    logoutUser() {
        return new Promise(function (resolve, reject) {
            IntercomModule.shutdownIntercom()
            axios
                .post(Vue.config.url_prefix + "/api/logout")
                .catch((err) => console.error(err))
                .finally(function () {
                    const PROTOCOL = process.env.VUE_APP_PROTOCOL ? process.env.VUE_APP_PROTOCOL : "";
                    const HOST = process.env.VUE_APP_HOST ? process.env.VUE_APP_HOST : "";
                    const BASE_URL = `${PROTOCOL}://${HOST}`;
                    window.location = BASE_URL + "/login";
                    resolve();
                })
        });
    },
    getMembers(params) {
        return new Promise(function (resolve, reject) {
            axios
                .get(Vue.config.url_prefix + "/api/a/{0}/users".format(params.account_id), { params: params })
                .then(function (resp) {
                    resolve(resp.data);
                })
                .catch(function (ex) {
                    reject(ex);
                });
        });
    },
    getGroupMembers(group_id) {
        return new Promise(function (resolve, reject) {
            axios
                .get(Vue.config.url_prefix + "/api/groups/{0}/members".format(group_id))
                .then(function (resp) {
                    resolve(resp.data);
                })
                .catch(function (ex) {
                    reject(ex);
                });
        });
    },
    refreshAccountSecurity(account_id) {
        return new Promise(function (resolve, reject) {
            axios
                .post(Vue.config.url_prefix + "/api/admin/accounts/{0}/refresh_security".format(account_id))
                .then(function () {
                    resolve();
                })
                .catch(function (ex) {
                    errorDialog.showError(ex);
                    reject(ex);
                });
        });
    }
};

export const getters = {
    current_account: computed(() =>
        Object.assign(
            state.current_account,
            state.list.find(acc => state.current_account.id === acc.id)
        )
    ),
    // it is set from app module which is imported as accountState there
    available_accounts: computed(() => state.list),
    available_account_for_clients: computed(() =>
        state.list.filter((a) => a.type === "company" || !getters.personalClientsProhibited.value)
    ),
    available_company_accounts: computed(() =>
        state.list.filter(a => a.id !== state.current_account.id && a.type === "company")
    ),
    getAccountInfo(account_id) {
        return state.accounts_info.find(x => x.id === account_id);
    },
    getAccount: account_id =>
        computed(() => {
            const acc_id = isRef(account_id) ? account_id.value : account_id;
            const found_account = state.list.find(account => Number(account.id) === Number(acc_id));
            if (found_account && state.current_account.id === found_account.id) {
                return Object.assign({}, state.current_account, found_account);
            }
            return found_account;
        }),
    getDefaultCompanyAccount(input_company_accounts) {
        let available_company_accounts = input_company_accounts.value !== undefined ? input_company_accounts.value : input_company_accounts;
        const default_account_id_str = getCookie("account_id");
        if (default_account_id_str && available_company_accounts && available_company_accounts.length) {
            let default_account_id = parseInt(default_account_id_str);
            let company_account = available_company_accounts.find(x => x.id === default_account_id);
            if (company_account != null)
                return company_account;
        }
        return available_company_accounts && available_company_accounts.length ?
            available_company_accounts[0] : null;
    },
    getAllAccountGroups() {
        return state.accounts_info.reduce((arr, account) => {
            return [...arr, ...account.members.filter((member) => member.type === 'group')]
        }, [])
    },
    personalClientsProhibited: computed(() => {
        const prohibitor = state.list.filter((a) => a.type === 'company' && a.data.disable_personal_clients_for_members)
        return prohibitor.length > 0
    })
};

export const key = Symbol("AccountModule");

export const provideAccount = () => {
    provide(key, {
        ...toRefs(state),
        ...getters,
        ...actions
    });
};

export default () => inject(key);
